import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import Autoplay from "%/dynamic-components/render-engine/options/video-options/autoplay";
import Controls from "%/dynamic-components/render-engine/options/video-options/controls";
import Muted from "%/dynamic-components/render-engine/options/video-options/muted";
import Poster from "%/dynamic-components/render-engine/options/video-options/poster";
import SingleVideo from "%/dynamic-components/render-engine/options/video-options/single-video";
import Loop from "%/dynamic-components/render-engine/options/video-options/loop";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

export default class VideoOptions extends BaseOptionsBundle {

  optionTitle = "Video";
  static optionClassName = "i-dynamic-video";
  inspectorToolGroup = "video";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.VIDEO_TOOLSET,
  };

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new SingleVideo(null, hideFromInspector["single-video"] ?? false),
      Autoplay,
      Controls,
      Loop,
      Muted,
      Poster,
    ]);
  }
}
